/* Flat cards remain visible. Paired mobile photographs can be browsed naturally. */
(() => {
  'use strict';
  if (window.LRSChapterCardsReady) return;
  window.LRSChapterCardsReady = true;
  const cards = new Map();
  let frame = 0;
  function measure() {
    frame = 0;
    cards.forEach((state, rail) => {
      const overflow = rail.scrollWidth > rail.clientWidth + 2;
      if (overflow) rail.setAttribute('tabindex', '0'); else rail.removeAttribute('tabindex');
      rail.dataset.cardsScrollable = String(overflow);
    });
  }
  const queue = () => { if (!frame) frame = requestAnimationFrame(measure); };
  function init(scope = document) {
    scope.querySelectorAll('[data-lrs-chapter-cards] [data-chapter-cards]').forEach(rail => {
      if (cards.has(rail)) return;
      const abort = new AbortController();
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || rail.dataset.cardsScrollable !== 'true' || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        rail.scrollBy({left: rail.clientWidth * (event.key === 'ArrowRight' ? .88 : -.88), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: abort.signal});
      const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(queue) : null;
      resize?.observe(rail);
      cards.set(rail, {abort, resize});
    });
    queue();
  }
  window.addEventListener('resize', queue, {passive: true});
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    cards.forEach((state, rail) => {
      if (!event.target.contains(rail)) return;
      state.abort.abort(); state.resize?.disconnect(); cards.delete(rail);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
})();
